import { render, staticRenderFns } from "./DesensitizationDialog.vue?vue&type=template&id=74485c28&scoped=true&"
import script from "./DesensitizationDialog.vue?vue&type=script&lang=js&"
export * from "./DesensitizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./DesensitizationDialog.vue?vue&type=style&index=0&id=74485c28&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74485c28",
  null
  
)

export default component.exports